import { api } from "../../api";
import {
	UserLoginDTO,
	UserLoginResponseDTO,
	ProductListResponseDTO,
	ProductResponseDTO,
	WishlistResponseDTO,
	MyShareCodeDTO,
	WishlistShareModeResponseDTO,
	MessageResponseDTO,
	CategoryResponseDTO,
	StoresResponseDTO,
} from "./user.dto";

export namespace UserApi {
	export function login(loginData: UserLoginDTO) {
		return api.post<UserLoginResponseDTO>("/login", loginData);
	}

	export function me() {
		return api.get("/me");
	}

	export function getProductList() {
		return api.get<ProductListResponseDTO[]>("/ec/items");
	}

	export function getCategory(id: number) {
		return api.get<CategoryResponseDTO>(`/ec/category/${id}`);
	}

	export function getProduct(id: number) {
		return api.get<ProductResponseDTO>(`/ec/items/${id}`);
	}

	export function toggleProductCollection(
		id: number,
		collection_status: boolean,
	) {
		let url = `/ec/myCollect/${id}`;
		if (collection_status) {
			return api.post(url);
		} else {
			return api.delete(url);
		}
	}

	export function getWishlist() {
		return api.get<WishlistResponseDTO[]>("/ec/myCollectList");
	}

	export function getShareCode() {
		return api.get<MyShareCodeDTO>(`/ec/myCollect/code`);
	}

	export function getFromLiffShareWishlist(code: string) {
		return api.get<WishlistShareModeResponseDTO>(`/ec/collect/code/${code}`);
	}

	export function sendOaMessage(styleCode: string, type: string) {
		return api.post<MessageResponseDTO>(`/ec/sendMessage/${type}`, {
			style_code: styleCode,
		});
	}

	export function storeManagerAssignSaForNewCustomer(
		styleCode: string,
		type: string,
		storeId: string,
	) {
		return api.post<MessageResponseDTO>(
			`/ec/storeManagerAssignSaForNewCustomer/${type}`,
			{
				style_code: styleCode,
				store_id: storeId,
			},
		);
	}

	export function getStores() {
		return api.get<StoresResponseDTO[]>(`/stores`);
	}
}
